import { render, staticRenderFns } from "./PIreorcd.vue?vue&type=template&id=94512252&scoped=true"
import script from "./PIreorcd.vue?vue&type=script&lang=js"
export * from "./PIreorcd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94512252",
  null
  
)

export default component.exports